module.exports = __webpack_public_path__ + "static/media/cnn.8a1515ec.png";